import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'appdashboard-not-found',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './notFound.component.html',
  styleUrls: ['./notFound.component.less']
})
export class NotFoundComponent implements OnInit, OnDestroy {


  constructor(
    private router: Router,
  ) {

  }

  ngOnInit() {
    
  }



  ngOnDestroy() {
  }
  
  
  goHome() {
    this.router.navigate(['/']);

  }
}
